import { render } from "./App.vue?vue&type=template&id=282edadf"
const script = {}

import "./App.vue?vue&type=style&index=0&id=282edadf&lang=css"
script.render = render

export default script